/***
* Add by jfzhu
* created:20190805
* 注:商家联盟拓客首页
*/
<template>
  <div class="item-div">
    <div class="form-div">
      <div class="item">
        <span v-if="cashType == 0">尾号:<span style="color:#3CA2E2">{{ bankCard }}</span></span>
        <span class="title-span">提现金额</span>
        <div class="input-price">
          <span>￥</span>
          <input type="number" v-model="money" oninput="value=value.replace(/[^\d.]/g,'')"/>
        </div>
        <span style="color: orange;">手续费 {{ deductMoney }} 元</span>
        <div class="info">
          <span>当前零钱余额 {{ totalMoney }} 元</span>
          <span @click="goDetail()">提现明细</span>
        </div>
        <div class="btn" @click="withdrawBtn()">提现</div>
        <div class="select-bank" @click="selectBank()" v-if="cashType == 0">点我选择银行卡</div>
      </div>
    </div>
    <nut-dialog title="提示" :visible="dialogShow" @ok-btn-click="finish()" @cancel-btn-click="dialogShow=false"
                @close="dialogShow=false">
      <p><span>提现金额:{{ money }}</span></p>
      <p><span>提现手续费:{{ deductMoney }}</span></p>
    </nut-dialog>
    <div class="explain" v-if="cashIntro!=''">
      <p>{{ cashIntro }}</p>
      <!--<p>提现说明:工作日24小时之内处理提现申请：提现几个必须10元起，每笔不能大于1000元，每笔收取{{service}}%的手续费，申请成功后将转微信零钱包。</p>
      <p
        style="color:#E60012"
      >注意事项：由于从2019年3月14日起提现直接将款转入到微信零钱包，第一次提现到微信零钱包时不能超过10元，充成功收到款后再次发起第二次提现。到账微信为该会员ID注册时的微信号</p>-->
    </div>
  </div>
</template>

<script>
var querydata = ''

export default {
  name: 'MerConfirmeAmount',
  data () {
    return {
      title: '提现',
      withdraw: 0,//提现额度
      withdrawBegin: 0,
      withdrawEnd: 0,
      withdrawCharge: 0,
      bankList: [],
      bankCard: '',
      bankId: '',
      totalMoney: 0,
      cashIntro: '',
      money: 0,
      deductMoney: 0,
      cashType: 0,//体现方式 0代表的银行卡 1代表微信零钱
      openid: this.$common.userinfo.openid,
      queryData: {},
      dialogShow: false,
    }
  },
  created () {
    this.$common.changetitle(this.title)
    this.queryData = this.$route.query
    if (this.$common.activitydata != '' && this.$common.activitydata.cashIntro != '') {
      this.cashIntro = this.$common.activitydata.cashIntro
      this.cashType = this.$common.activitydata.cashType
    }
  },
  mounted () {
    this.getSpreadSet()
    this.getBanUserList()
    this.getUserMoney()
  },
  methods: {
    getUserMoney () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/extend-money',
        data: {
          uid: this.queryData.uid,
          merId: this.queryData.merId
        },
        login: false
      }).then(res => {
        this.totalMoney = res.data || 0
      })
    },
    //获取提现的手续费等配置信息
    getSpreadSet () {
      this.$api.post({
        url: '/merchant/web/merchant-spread-set/find',
        data: {
          merId: this.queryData.merId
        },
        login: false
      }).then(res => {
        if (res.data != null) {
          this.withdraw = res.data.withdraw || 0
          this.withdrawBegin = res.data.withdrawbegin || 0
          this.withdrawEnd = res.data.withdrawend || 0
          this.withdrawCharge = res.data.withdrawcharge || 0
        }
      })
    },
    getBanUserList () {
      this.$api.post({
        url: '/system/bank-user/mer/list',
        data: {
          merId: this.queryData.merId,
          uid: this.queryData.uid
        },
        login: false
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          if (res.data.length <= 1) {
            this.bankCard = res.data[0].bankCard.slice(-4)
            this.bankId = res.data[0].id
          } else {
            this.bankList = res.data
          }
        }
      })
    },
    selectBank: function () {
      this.$router.push({
        path: '/MerTokerBankcardList',
        query: {
          merId: this.queryData.merId,
          activityId: this.queryData.activityId,
          storeId: this.queryData.storeId,
          fansid: this.queryData.fansid,
          uid: this.queryData.uid
        }
      })
    },
    goDetail () {
      this.$router.push({
        path: '/MerTokerCashDetail',
        query: {
          merId: this.queryData.merId,
          uid: this.queryData.uid,
          moneyType: 1
        }
      })
    },
    //提现
    withdrawBtn () {
      if (this.money < this.withdraw) {
        alert('提现金额需大于' + this.withdraw + '元额度时才能提现')
        this.dialogShow = false
        return
      }
      if (this.money > this.totalMoney) {
        alert('输入金额超过零钱余额')
        return
      }
      let withdrawCharge = this.withdrawCharge
      let withdrawEnd = this.withdrawEnd
      if (this.cashType == 1 && this.money > 5000) {
        this.money = 5000
      }
      if (this.cashType == 0 && this.money > 20000) {
        this.money = 20000
      }
      if (this.totalMoney >= this.money) {
        //判断计算手续费后的提现金额是否一致
        this.deductMoney = this.money * (withdrawCharge / 100).toFixed(2)
        if (this.money <= withdrawEnd) {
          this.deductMoney = 0
        }
      }
      if (this.deductMoney > 0) {
        this.money = (this.money - this.deductMoney).toFixed(2)
      }
      this.dialogShow = true
    },
    //确认
    finish () {
      let data = {
        merId: this.queryData.merId,
        uid: this.queryData.uid,
        openid: this.openid,
        money: this.money,
        deductMoney: this.deductMoney,
        cashType: this.cashType == 0 ? 2 : this.cashType,
        content: '提现'
      }
      if (this.cashType == 0 && this.$util.isArrOrNull(this.bankId)) {
        alert('请先选择银行卡')
        this.dialogShow = false
        return
      } else {
        data.bankId = this.bankId
      }
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/cash',
        data: data,
        login: false
      }).then(res => {
        this.$router.push({
          path: '/MerTokerCapitalDetail',
          query: {
            merId: this.queryData.merId,
            uid: this.queryData.uid,
            activityId: this.queryData.activityId
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.item-div {
  margin-top: 50px;
  font-size: 14px;
}

.item-div .form-div {
  height: 270px;
  border-bottom: 3px dotted #4e4c4c;
  margin: 60px 8%;
}

.item-div .form-div .item {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 30px;
  padding: 24px;
}

.item-div .form-div .item .title-span {
  margin: 8px 0;
}

.item-div .form-div .item .input-price {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
}

.item-div .form-div .item .input-price input {
  border: none;
  height: 100%;
  width: 100%;
  margin-left: 5px;
  padding: 0;
  font-size: 15px;
  border-bottom: 1px solid #666666;
}

input:focus {
  outline: none;
}

.item-div .form-div .item .info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #b3b3b3;
  line-height: 100px;
}

.item-div .form-div .item .btn {
  width: 80%;
  margin-left: 10%;
  height: 35px;
  color: #fff;
  text-align: center;
  line-height: 35px;
  font-size: 17px;
  background-color: #209ae0;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  margin-top: -10px;
}

.item-div .form-div .item .select-bank {
  width: 80%;
  margin-left: 10%;
  text-align: center;
  color: #7ff332;
  line-height: 35px;
}

.explain {
  width: 80%;
  height: auto;
  margin-left: 10%;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerConfirmeAmount.vue